export const REGEXP = {
    noDigits: /[^\d]/g,
    leadingZeros: /\b0+/g,
};

export const replaceToPositiveNumbers = (text: string) =>
    text.replace(REGEXP.noDigits, '').replace(REGEXP.leadingZeros, '');
